function toggleOverlay(event) {
    event.preventDefault();
    const { hash } = this;
    const overlay = document.querySelector(`.overlay${hash}`);
    const isOverlayOpen = document.body.classList.contains('overlay-opened');
    if (!overlay) {
        console.error(`Overlay "${hash}" does not exist.`);
    } else if (!isOverlayOpen) {
        overlay.classList.toggle("overlay-shown");
        document.body.classList.toggle("overlay-opened");
    }
    else {
        overlay.classList.add("overlay-fadeout");
        setTimeout(function() {
            overlay.classList.toggle("overlay-shown");
            document.body.classList.toggle("overlay-opened");
            overlay.classList.remove("overlay-fadeout");
        }, 1000);
    }
}

[...document.querySelectorAll(".overlay-toggle > a")].map((o) => o.addEventListener("click", toggleOverlay));
